import { useNavigate } from "react-router-dom";

export default function BackToDashboardButton() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="page-content__button--medium page-content__button--back page-content__button--inline mb-3"
      id="page-navigation-button--go-back"
      onClick={() => navigate('/conversations')}
    >
      Back to Dashboard
    </button>
  );
}